import { IThreeVariantXP } from '../../indigofair/settings/IThreeVariantXP';
import { SettingConst } from '../../types';

/**
 * Testing new header copy on logged out homepage top banner
 */
export const LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224 =
  'LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224' as SettingConst<
    'LOGGED_OUT_HOMEPAGE_NEW_TOP_BANNER_COPY_112224',
    keyof typeof IThreeVariantXP.Bucket,
    'RETAILER'
  >;
